import { extractCodeSections, restoreCodeSections, extractEscapes, restoreEscapes, stripMarkupHeader, } from "./src/preprocess.js";
import { parseBlocks } from "./src/blockParser.js";
import { renderBlocks } from "./src/renderer.js";
import { dropBackslashEscapes } from "./src/postprocess.js";
import { htmlToMarkup } from "./src/htmlToMarkup.js";
import { fullEscapeHTML, fullUnescapeHTML } from "./src/htmlUtil.js";
export function ApckMarkupToHtml(markup, options) {
    // 1. Pre-process: extract code sections and escaped characters
    const { processed: codeProcessed, codeBlocks } = extractCodeSections(markup);
    const { processed: escProcessed, escapes } = extractEscapes(codeProcessed);
    const stripped = stripMarkupHeader(escProcessed);
    // 2. Parse blocks
    const blocks = parseBlocks(stripped, options);
    // 3. Render to HTML
    let html = renderBlocks(blocks);
    // 4. Post-process
    html = dropBackslashEscapes(html);
    html = restoreEscapes(html, escapes);
    html = restoreCodeSections(html, codeBlocks);
    return html;
}
export { htmlToMarkup as HtmlToApckMarkup, htmlToMarkup, fullEscapeHTML, fullUnescapeHTML, };
